import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey40 } from "@churchofjesuschrist/eden-style-constants";
import { Text4 } from "@churchofjesuschrist/eden-text";
const DescriptionStyled = styled(Text4).withConfig({
  componentId: "sc-cw2mou-0"
})(["color:", ";"], grey40);

const Description = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(DescriptionStyled, props, children);
};

Description.propTypes = {
  /** Description Content */
  children: PropTypes.node.isRequired
};
export default Description;